import { Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import PropTypes from "prop-types";

export const CustomDateRangePicker = ({
  clearable = true,
  // New explicit props
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  // Legacy props for backward compatibility
  dateRange,
  onChanged,
  minStartDate,
  maxEndDate,
  disabled,
  startLabel = "Tanggal Awal",
  endLabel = "Tanggal Akhir",
  format = "DD MMM YYYY",
}) => {
  // Use explicit props if provided, otherwise fallback to dateRange object
  const currentStartDate = startDate !== undefined ? startDate : dateRange?.startDate;
  const currentEndDate = endDate !== undefined ? endDate : dateRange?.endDate;
  const currentMaxEndDate = maxEndDate !== undefined ? maxEndDate : dayjs();

  const handleStartDateChange = (newDate) => {
    const newDateValue = newDate ? dayjs(newDate) : null;

    if (onStartDateChange) {
      // Use explicit callback
      onStartDateChange(newDateValue);
    } else if (onChanged && dateRange) {
      // Use legacy callback
      onChanged({
        ...dateRange,
        startDate: newDateValue,
      });
    }
  };

  const handleEndDateChange = (newDate) => {
    const newDateValue = newDate ? dayjs(newDate) : null;

    if (onEndDateChange) {
      // Use explicit callback
      onEndDateChange(newDateValue);
    } else if (onChanged && dateRange) {
      // Use legacy callback
      onChanged({
        ...dateRange,
        endDate: newDateValue,
      });
    }
  };

  return (
    <Stack direction={"row"} spacing={2}>
      <DatePicker
        label={startLabel}
        format={format}
        value={currentStartDate}
        minDate={minStartDate}
        maxDate={currentEndDate || dayjs()}
        onChange={handleStartDateChange}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth: true,
            clearable,
            disabled: disabled
          }
        }}
      />
      <DatePicker
        label={endLabel}
        format={format}
        value={currentEndDate}
        minDate={currentStartDate}
        maxDate={currentMaxEndDate}
        onChange={handleEndDateChange}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth: true,
            clearable,
            disabled: disabled
          }
        }}
      />
    </Stack>
  );
};

export default CustomDateRangePicker;

CustomDateRangePicker.propTypes = {
  clearable: PropTypes.bool,
  // New explicit props
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  // Legacy props for backward compatibility
  dateRange: PropTypes.object,
  onChanged: PropTypes.func,
  minStartDate: PropTypes.object,
  maxEndDate: PropTypes.object,
  disabled: PropTypes.bool,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  format: PropTypes.string,
};
